/*
The type could be "opportunity" or "highlight"
 */
import React from "react";
import "./styles.scss";

export default class vehicleCardFlag extends React.Component {
  render() {
    var flagText = this.props.children;
    var type = this.props.type;

    return <div className={`vehicleCardFlag ${type}`}>{flagText}</div>;
  }
}
